import { useQuery } from '@tanstack/react-query'
import useUserContext from 'shared/users/contexts/useUserContext'
import { QueryKeys } from '../../../../key-registry'
import { fromDirectoEventResponse } from '../models/mapper'
import { DirectoEvent } from '../models/types'
import { fetchDirectoEventV2 } from './http'

export async function fetchDirectoEvent(
  params: { transitOperationId: number },
  opts?: { signal?: AbortSignal },
): Promise<DirectoEvent> {
  const response = await fetchDirectoEventV2(params, opts)
  return fromDirectoEventResponse(response)
}

export function useFetchDirectoEvent(directoEventId: number | null, transitOperationId: number | null) {
  const { isAdmin } = useUserContext()
  return useQuery({
    queryKey: QueryKeys.directoEvent.detailsByParams({ transitOperationId }),
    queryFn: ({ signal }) => fetchDirectoEvent({ transitOperationId: transitOperationId as number }, { signal }),
    enabled: !!directoEventId && !!transitOperationId && isAdmin,
  })
}
